<template>
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Filtrar:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                                    <option value="0">Código</option>
                                    <option value="1">Descrição</option>
                                </select>
                            </div>
                            <div class="col-sm-8 col-md-6 col-lg-6">
                                <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table ref="reflstselecionados" @on-select-row="mtdselecionadostable()"
                                        @on-unselect-row="mtdselecionadostable()"
                                        @on-all-select-rows="mtdselecionadostable()"
                                        @on-all-unselect-rows="mtdselecionadostable()"
                                        :rows="lstperfis"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="id_f" slot-scope="item">
                                        {{ item.row.id }}
                                    </template>
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterar(item.row)"><i class="fa fa-edit"></i></button>
                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)"><i class="fa fa-trash"></i></button>
                                        <button type="button" class="btn btn-success btn-sm btn-opcrud ajt-btn" @click.prevent="mtdclonar(item.row)" title="Clonar pdv"><i class="fa fa-copy"></i></button>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstperfis.length}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <!--Paginador-->
                            <div class="col-6 col-sm-6 col-md-8 col-lg-6" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>

                            <!--Luiz Trindade - Botão para alterações em massa-->
                            <div class="col-2 col-sm-2 col-md-2 col-lg-2">
                                <div class="dropdown">
                                    <button v-show="parseInt(pqtdselecionados) > 0" type="button" 
                                    class="btn btn-info btn-sm btn-block dropdown-toggle" 
                                    data-toggle="dropdown">
                                        <i class="fa fa-navicon"></i>
                                        Outras
                                    </button>

                                    <!--Itens do menu dropdown-->
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="#" @click.prevent="mtdrotinacampos()">
                                            <i class="fa fa-list"></i>
                                            Atribuir campos
                                        </a>                                                                                                                     
                                    </div>
                                </div>  
                            </div>

                            <!--Botão para definir conta-->
                            <div class="col-2 col-sm-2 col-md-2 col-lg-2">
                                <button v-show="parseInt(pqtdselecionados) > 0" type="button" class="btn btn-info btn-sm btn-block" @click.prevent="mtddefinirconta()"><i class="fa fa-bank"></i> Definir Conta</button>
                            </div> 
                            
                            <!--Botão para adicionar um novo perfil de fluxo de caixa-->
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edid">Código:</label>
                                <input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
                                       maxlength="20" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="eddescricao">*Descrição:</label>
                                <input type="text" v-model="vdescricao" v-bind:disabled="ativadesativa"
                                       class="form-control form-control-sm" id="eddescricao" maxlength="50">
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <span class="lblselect2">*Conta:</span>
                                <select id="cbconta" data-placeholder="Selecione uma opção"
                                    v-model="vidconta" 
                                    data-allow-clear="true" style="width:100%;" v-bind:disabled="ativadesativa">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <span class="lblselect2">*Plano de contas:</span>
                                <select id="cbplanoconta" data-placeholder="Selecione uma opção"
                                    v-model="vidplanoconta" 
                                    data-allow-clear="true" style="width:100%;" v-bind:disabled="ativadesativa">
                                </select>
                            </div>                                                 
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <span class="lblselect2">*Centro de custo:</span>
                                <select id="cbcentrocusto" data-placeholder="Selecione uma opção"
                                    v-model="vidcentrocusto" 
                                    data-allow-clear="true" style="width:100%;" v-bind:disabled="ativadesativa">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <span class="lblselect2">*Provedor de custo:</span>
                                <select id="cbprovedorcusto" data-placeholder="Selecione uma opção"
                                    v-model="vidprovedorcusto" 
                                    data-allow-clear="true" style="width:100%;" v-bind:disabled="ativadesativa">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <span class="lblselect2">*Histórico padrão:</span>
                                <select id="cbhistoricopadrao" data-placeholder="Selecione uma opção"
                                    v-model="vidhistoricopadrao" 
                                    data-allow-clear="true" style="width:100%;" v-bind:disabled="ativadesativa">
                                </select>
                            </div>                                                               
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="eddescricaomovimento">*Abreviação do movimento:</label>
                                <input type="text" v-model="vdescricaomovimento" v-bind:disabled="ativadesativa"
                                       class="form-control form-control-sm" id="eddescricao" maxlength="50">
                            </div>                        
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <label for="eddescritivoconciliacao">Descritivo conciliação:</label>
                                <input type="text" v-model="vdescritivoconciliacao" v-bind:disabled="ativadesativa"
                                       class="form-control form-control-sm" id="eddescricao" maxlength="50">
                            </div>                        
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edtaxa">Taxa(%):</label>
                                <money type="text" class="form-control form-control-sm" id="edtaxa"
                                        v-model="vtaxa" v-bind="money" v-bind:disabled="ativadesativa"
                                        data-bv-group=".group" style="text-align:right;">
                                </money>
                            </div>                                    
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

		<!-- Modal para atribuir a conta -->
		<div class="modal fade" id="mddefineconta">
			<div class="modal-dialog modal-md modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title" style="font-size: 16px;"><i class="fa fa-bank"></i> Definir conta</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>				
				<div class="modal-body">
					<div class="row">
						<div class="col-12">
							<span class="lblselect2">Conta:</span>
							<select id="cbcontadef" data-placeholder="Selecione uma conta" v-model="vidcontadef" data-allow-clear="true" style="width:100%;">
							</select>
						</div>		
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-primary btn-sm" style="width: 100px;" @click.prevent="mtdatribuirconta()"><i class="fa fa-check"></i> Confirmar</button>
					<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Cancelar</button>
				</div>				        
			</div>
			</div>
		</div>  
        
        <!--Luiz Trindade - Modal de atribuir campos para alterações em massa nos perfis de fluxo-->
        <div class="modal fade" id="mdatribuircampos" tabindex="-1" ref="mdatribuircampos">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <!--Luiz Trindade - cabeçalho do modal-->
                    <div class="modal-header">
                        <i class="fa fa-leanpub" style="margin-top: 8px; margin-right: 7px"></i>
                        <h4 class="modal-title" style="color: #fff;">
                            Atribuir campos aos perfis de fluxo
                        </h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <!--Luiz Trindade - Corpo do modal-->
                    <div class="modal-body" style="padding-top: 5px;">
                        <!--Luiz Trindade - Primeira linha-->
                        <div class="row">
                            <!--Luiz Trindade - Checkbox de plano de contas-->
                            <div class="col-sm-1 col-md-1 col-lg-1">
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" 
                                        id="cbatribuirplanodecontas" v-model="vatribuirplanodecontas">
                                    <label class="custom-control-label" for="cbatribuirplanodecontas"></label>
                                </div>
                            </div>
                            <!--Luiz Trindade - Plano de contas-->
                            <div class="col-sm-11 col-md-5 col-lg-5">
                                <span class="lblselect2">Plano de contas:</span>
                                <select id="cbplanoconta2" data-placeholder="Selecione um plano de contas" 
                                    v-model="vplanodecontas" v-bind:disabled="!vatribuirplanodecontas" 
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>

                            <!--Luiz Trindade - Checkbox de centro de custo-->
                            <div class="col-sm-1 col-md-1 col-lg-1">
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuircentrodecusto" v-model="vatribuircentrodecusto">
                                    <label class="custom-control-label" for="cbatribuircentrodecusto"></label>
                                </div>
                            </div>
                            <!--Luiz Trindade - centro de custo-->
                            <div class="col-sm-11 col-md-5 col-lg-5">
                                <span class="lblselect2">Centro de custo:</span>
                                <select id="cbcentrocusto2" data-placeholder="Selecione um centro de custo" 
                                    v-model="vcentrodecusto" v-bind:disabled="!vatribuircentrodecusto" 
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                        </div>

                        <!--Luiz Trindade - Segunda linha-->
                        <div class="row">
                            <!--Luiz Trindade - Checkbox de provedor de custo-->
                            <div class="col-sm-1 col-md-1 col-lg-1">
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" 
                                        id="cbatribuirprovedordecusto" v-model="vatribuirprovedordecusto">
                                    <label class="custom-control-label" for="cbatribuirprovedordecusto"></label>
                                </div>
                            </div>
                            <!--Luiz Trindade - Provedor de custo-->
                            <div class="col-sm-11 col-md-5 col-lg-5">
                                <span class="lblselect2">Provedor de custo:</span>
                                <select id="cbprovedorcusto2" data-placeholder="Selecione um provedor de custo" 
                                    v-model="vprovedordecusto" v-bind:disabled="!vatribuirprovedordecusto" 
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>

                            <!--Luiz Trindade - Checkbox do histórico padrão-->
                            <div class="col-sm-1 col-md-1 col-lg-1">
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuirhistoricopadrao" v-model="vatribuirhistoricopadrao">
                                    <label class="custom-control-label" for="cbatribuirhistoricopadrao"></label>
                                </div>
                            </div>
                            <!--Luiz Trindade - Histórico padrão-->
                            <div class="col-sm-11 col-md-5 col-lg-5">
                                <span class="lblselect2">Histórico padrão:</span>
                                <select id="cbhistoricopadrao2" data-placeholder="Selecione um histórico padrão" 
                                    v-model="vhistoricopadrao" v-bind:disabled="!vatribuirhistoricopadrao" 
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                        </div>
                    </div>

                    <!--Luiz Trindade - Rodapé do modal-->
                    <div class="modal-footer">
                        <!--Luiz Trindade - botão de confirmar-->
                        <button id="btconfirmar" type="button" @click.prevent="mtdatribuircampos()" 
                            class="btn btn-primary btn-sm">
                                <i class="fa fa-check"></i>
                                Confirmar
                        </button>
                        
                        <!--Luiz Trindade - botão de cancelar-->
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">
                            <i class="fa fa-close"></i>
                            Cancelar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import util from '../utilitarios/util.js'

    export default {
        name: 'cadperfilfluxo',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb' : BreadCrumb
        },
        data: function() {
            return {
                lstperfis  : [],
                pfiltro      : 1,
                pconteudo    : '',
                pqtdregistros: 10,
                pqtd_paginas : 1,
                pagina_atual : 1,
                pqtd_total_registros: 0,

                //variáveis do crud
                opcrud              :  0,
                vid                 : '',
                vdescricao          : '',
                vidconta            : null,
                vidplanoconta       : null,
                vidcentrocusto      : null,
                vidhistoricopadrao  : null,
                vdescricaomovimento : '',
                vidprovedorcusto    : null,
                vdescritivoconciliacao : '',
                vtaxa                  : 0,

                pqtdselecionados       : 0, 
                vidcontadef            : null,
                //variável para habilitação dos campos
                ativadesativa       : true,

                //Luiz Trindade - Variáveis de checkbox de alteração em massa dos perfis de fluxo
                vatribuirplanodecontas          : false,
                vatribuircentrodecusto          : false,
                vatribuirprovedordecusto        : false,
                vatribuirhistoricopadrao        : false,
                //Luiz Trindade - Variáveis de alteração em massa dos perfis de fluxo
                vplanodecontas                  : null,
                vcentrodecusto                  : null,
                vprovedordecusto                : null,
                vhistoricopadrao                : null,
                vdescricaomovimento2            : '',


                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'PERFIL FLUXO CAIXA',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes-perfil",
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "id",
                        sort: true,
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Descrição",
                        name: "descricao",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Conta",
                        name: "descconta",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    }
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false,
                    checkbox_rows: true
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                },
                money: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',//aqui colocar o cifrão se for necessário
                    precision       : 2,
                    masked          : false
                }
            }
        },
        methods:{
            //Luiz Trindade - Método para exibir o modal de atribuir mudanças em massa
            mtdrotinacampos(){
                this.vatribuirplanodecontas        = false;
                this.vatribuircentrodecusto        = false;
                this.vatribuirprovedordecusto      = false;
                this.vatribuirhistoricopadrao      = false;

                $('#cbplanoconta2').val(null).trigger('change');
                $('#cbcentrocusto2').val(null).trigger('change');
                $('#cbprovedorcusto2').val(null).trigger('change');
                $('#cbhistoricopadrao2').val(null).trigger('change');

                $('#mdatribuircampos').modal('show');
            },    

            //Luiz Trindade - Método para atribuir campos
            mtdatribuircampos(){
                // console.log("Método para atribuir campos");
                let vself = this;
				if (this.vatribuirplanodecontas === true && this.vplanodecontas === null){
					this.$toastr.w('Campo "Plano de contas deve ser informado" foi selecionado, portanto, deve ser informado!', 'Atenção!');
					$('#cbplabocontas2').focus();
					return;
                }

                if (this.vatribuircentrodecusto === true && this.vcentrodecusto === null){
					this.$toastr.w('Campo "Centro de custo" foi selecionado, portanto, deve ser informado!', 'Atenção!');
					$('#cbcentrocusto2').focus();
					return;
                }

                if (this.vatribuirprovedordecusto === true && this.vprovedordecusto === null){
					this.$toastr.w('Campo "provedor de custo" foi selecionado, portanto, deve ser informado!', 'Atenção!');
					$('#cbprovedorcusto2').focus();
					return;
                }
                if (this.vatribuirhistoricopadrao === true && this.vhistoricopadrao === null){
					this.$toastr.w('Campo "Histórico padrão" foi selecionado, portanto, deve ser informado!', 'Atenção!');
					$('#cbhistoricopadrao2').focus();
					return;
                }

                let sqlToSend = "";

                if (this.vatribuirplanodecontas === true && this.vplanodecontas !== null){
                    sqlToSend += " idplanoconta = '"+this.vplanodecontas+"',";
                }
                if (this.vatribuircentrodecusto === true && this.vcentrodecusto !== null){
                    sqlToSend += " idcentrocusto = "+this.vcentrodecusto+",";
                }
                if (this.vatribuirprovedordecusto === true && this.vprovedordecusto !== null){
                    sqlToSend += " idprovedorcusto = "+this.vprovedordecusto+",";
                }
                if (this.vatribuirhistoricopadrao === true && this.vhistoricopadrao !== null){
                    sqlToSend += " idhistoricopadrao = "+this.vhistoricopadrao;
                }
                if (sqlToSend[sqlToSend.length-1] == ","){
                    sqlToSend = sqlToSend.substring(0, sqlToSend.length-1);
                }

                console.log(sqlToSend);

                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma a atribuição dos campos aos perfis de fluxo selecionados?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: true,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                this.buttons.sim.disable();
                                setTimeout(function(){
                                    console.log("Chegou aqui!");
                                    let selecionados = vself.$refs.reflstselecionados.selected_items;
                                    let selecionadosID = [];
                                    selecionados.forEach(element => {
                                        selecionadosID.push(element.id);
                                    });
                                    let loader = vself.$loading.show();
                                    let parametros = [
                                        {parametro: 'op',               valor : 'alterarperfisfluxomassa'},
                                        {parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
                                        {parametro: 'idfilial',         valor : vself.$store.state.filialpadrao.codfil},
                                        {parametro: 'idusuario',        valor : vself.$store.state.usuario.id},
                                        {parametro: 'selecionadosID',   valor : selecionadosID},
                                        {parametro: 'sqlToSend',        valor : sqlToSend}
                                    ];

                                    let retorno = util.reqaxios(
                                        parametros, 'post', vself.$store.state.usuario.adrsrv
                                        +'/controller/rtcadperfilfluxocaixa.php'
                                    );
                                    retorno.then(function (response) {
                                        loader.hide();
                                        vself.$toastr.s('Sucesso ao alterar perfis de fluxo em massa!', 'Sucesso!');
                                        $('#mdatribuircampos').modal('hide');
                                    }).catch(function (response) {
                                        loader.hide();
                                        vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                    });
                                }, 200);
                            },
                        },

                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btconfirmar').focus();
                            }
                        }
                    }
                });
            },

            mtdselecionadostable(){
                this.pqtdselecionados = this.$refs.reflstselecionados.selected_items.length;
            },
            mtddefinirconta(){
                if (!util.opcaousuario('001Z.110Z.040Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {                                     
                    if (this.$refs.reflstselecionados.selected_items.length > 0){
                        $('#mddefineconta').modal('show');
                    }else{
                        this.$toastr.w('Selecione os perfis para definição da conta!', 'Informação!');
                    }
                }
            },
            mtdatribuirconta(){
                let vself = this;
                if (vself.vidcontadef !== null){
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Confirma atribuição da conta para o(s) perfil(s) selecionado(s)?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,
                        buttons: {
                            sim: {
                                text: '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-blue',
                                action: function () {
                                    $('.btn-blue').prop('disabled', true);
                                    vself.mtdgravarconta();
                                },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {
                                }
                            }
                        }
                    });
                }else{
                    vself.$toastr.w('Conta deve ser informada!', 'Informação!');                    
                    $('#cbcontadef').select('open');
                }
            },
            mtdgravarconta(){
                let vself  = this;
                let loader = vself.$loading.show();
                let dados = {
                    'idconta'               : vself.vidcontadef,
                    'perfis'                : this.$refs.reflstselecionados.selected_items
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'atribuirconta'},
                    {parametro: 'dados',        valor : JSON.stringify(dados)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : '001Z.110Z.040Z'}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadperfilfluxocaixa.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data.ret)){
                        $('#mddefineconta').modal('hide');
                        vself.$toastr.s('Conta definida com sucesso!', 'Informação!'); 
                        vself.pqtd_paginas   = 1;
                        vself.mtdlimpar_listagem();
                        vself.mtdcarregaperfis(1);                                          
                    }else{
                        let tpret = response.data.ret.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.ret.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.ret.substring(4), 'Erro!');
                                break;
                        }
                    }                    
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                    $('#mddefineconta').modal('hide');
                });               
            },
            mtdfiltropesquisa(){
                let rfiltro = '';
                if (parseInt(this.pfiltro) === 0){
                    rfiltro = this.pconteudo === '' ? '' : ' and p.id='+this.pconteudo;
                }else{
                    rfiltro = this.pconteudo === '' ? '' : ' and upper(p.descricao) like upper("'+this.pconteudo+'%")';
                }
                return rfiltro;
            },            
            mtddefinicoesiniciais(){
                let vself = this;
                $("#cbconta").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbcontasfluxocaixa',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidconta = $("#cbconta").val();
                });                
                $("#cbplanoconta").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbplanosconta',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidplanoconta = $("#cbplanoconta").val();
                });
                
                //Luiz Trindade - Select2 de plano de conta para alterações em massa
                $("#cbplanoconta2").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbplanosconta',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vplanodecontas = $("#cbplanoconta2").val();
                });


                $("#cbcentrocusto").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbcentroscustos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidcentrocusto = $("#cbcentrocusto").val();
                });

                //Luiz Trindade - Select2 de centro de custo para alterações em massa
                $("#cbcentrocusto2").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbcentroscustos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vcentrodecusto = $("#cbcentrocusto2").val();
                });

                $("#cbprovedorcusto").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbprovedorescustos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidprovedorcusto = $("#cbprovedorcusto").val();
                });
                
                //Luiz Trindade - Select2 provedor de custo
                $("#cbprovedorcusto2").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbprovedorescustos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vprovedordecusto = $("#cbprovedorcusto2").val();
                });

                $("#cbhistoricopadrao").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbhistoricospadroes',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidhistoricopadrao = $("#cbhistoricopadrao").val();
                    if (vself.vidhistoricopadrao !== null){
                        if (vself.vdescricaomovimento === ''){
                            vself.vdescricaomovimento = $("#cbhistoricopadrao").select2('data')[0]['text'];
                        }
                    }
                });

                //Luiz Trindade - Select2 histórico padrão
                $("#cbhistoricopadrao2").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbhistoricospadroes',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vhistoricopadrao = $("#cbhistoricopadrao2").val();
                    if (vself.vhistoricopadrao !== null){
                        if (vself.vdescricaomovimento2 === ''){
                            vself.vdescricaomovimento2 = $("#cbhistoricopadrao2").select2('data')[0]['text'];
                        }
                    }
                });
                
				$('#mddefineconta').on('shown.bs.modal', function (e) {
                    vself.vidcontadef = null;
                    $("#cbcontadef").val(null).trigger('change');
                    $("#cbcontadef").select2('open');
				});

                $("#cbcontadef").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbcontasfluxocaixa',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidcontadef = $("#cbcontadef").val();
                });                 
            },            
            mtdexecutapesquisa(){
                var vself           = this;
                let filtro          = vself.mtdfiltropesquisa();

                this.$refs.reflstselecionados.selected_items = [];
                this.mtdselecionadostable();

                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadperfilfluxocaixa.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregaperfis(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregaperfis(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadperfilfluxocaixa.php');
                retorno.then(function (response) {
                    vself.lstperfis = response.data;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstcheclists = [];
                    loader.hide();
                });
            },
            resetarDados() {
                util.toTop();

                this.vid                = '';
                this.vdescricao         = '';
                this.vidconta            = null;
                this.vidplanoconta       = null;
                this.vidcentrocusto      = null;
                this.vidhistoricopadrao  = null;
                this.vdescricaomovimento = '';
                this.vidprovedorcusto    = null;
                this.vdescritivoconciliacao = '';
                this.vtaxa                  = 0;

                $('#cbconta').val(null).trigger('change');
                $('#cbplanoconta').val(null).trigger('change');
                $('#cbcentrocusto').val(null).trigger('change');
                $('#cbprovedorcusto').val(null).trigger('change');
                $('#cbhistoricopadrao').val(null).trigger('change');                                                        

            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                this.$nextTick(function () {
                    if (parseInt(this.opcrud) < 3) {
                        $('#eddescricao').focus();
                    } else {
                        $('#btgravar').focus();
                    }
                });
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvperfil"]').tab('show');
                vself.mtddefault();
            },
            mtdnovo(){
                if (!util.opcaousuario('001Z.110Z.010Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE PERFIL FLUXO CAIXA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                }
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lstperfis = [];
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },
            mtdgravar(){
                let vself = this;
                if (parseInt(vself.opcrud) < 3) {
                    if (parseInt(vself.vtodasfiliais) === 0) {
                    }
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdregistro();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and p.id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadperfilfluxocaixa.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.mtdigualarcampos(response.data[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                if (!util.opcaousuario('001Z.110Z.020Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'ALTERAÇÃO DE PERFIL FLUXO CAIXA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdexcluir(item){
                if (!util.opcaousuario('001Z.110Z.030Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'EXCLUSÃO DE PERFIL FLUXO CAIXA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdclonar(item){
                if (!util.opcaousuario('001Z.110Z.010Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE PERFIL FLUXO CAIXA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                    this.mtdlocalizaregistro(item.id);                                        
                }
            },            
            mtdigualarcampos(registro){
                let vself = this;
                vself.vid                 = registro.id;
                vself.vdescricao          = registro.descricao;
                vself.vdescricaomovimento = registro.descricaomovimento;
                vself.vdescritivoconciliacao = registro.descritivoconciliacao;
                vself.vtaxa                  = registro.taxa;

                vself.vidconta  = registro.idconta;                            
				var defconta    = new Option(registro.descconta, vself.vidconta, true, true);
				$('#cbconta').append(defconta).trigger('change');

                vself.vidplanoconta  = registro.idplanoconta;
                var defplanoconta    = new Option(registro.descplanoconta, vself.vidplanoconta, true, true);
                $('#cbplanoconta').append(defplanoconta).trigger('change');

				vself.vidcentrocusto = registro.idcentrocusto;                            
				var defcentro    = new Option(registro.desccentrocusto, vself.vidcentrocusto, true, true);
				$('#cbcentrocusto').append(defcentro).trigger('change');

				vself.vidprovedorcusto    = registro.idprovedorcusto;
				var defprov    = new Option(registro.descprovedorcusto, vself.vidprovedorcusto, true, true);
				$('#cbprovedorcusto').append(defprov).trigger('change');
				
				vself.vidhistoricopadrao  = registro.idhistoricopadrao;                                
				var defhist    = new Option(registro.deschistoricopadrao, vself.vidhistoricopadrao, true, true);
				$('#cbhistoricopadrao').append(defhist).trigger('change');                                

            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'id'                : this.vid,
                    'descricao'         : this.vdescricao,
                    'idconta'           : this.vidconta,
                    'idplanoconta'      : this.vidplanoconta,
                    'idcentrocusto'     : this.vidcentrocusto,
                    'idhistoricopadrao' : this.vidhistoricopadrao,
                    'idprovedorcusto'   : this.vidprovedorcusto,
                    'descricaomovimento': this.vdescricaomovimento,
                    'descritivoconciliacao' : this.vdescritivoconciliacao,
                    'taxa'                  : this.vtaxa
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '001Z.110Z.010Z' : parseInt(this.opcrud) === 2 ? '001Z.110Z.020Z' : '001Z.110Z.030Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadperfilfluxocaixa.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.pfiltro       = 0;
                        vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregaperfis(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            }
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (parseInt(vself.$store.state.filialpadrao.plnc) < 2){
                        vself.$swal.fire({
                                            position: 'bottom-end',
                                            //icon: 'success',
                                            title: 'Atenção!',
                                            html: 'Seu plano não contempla esta funcionalidade! Favor entrar em contato com a <strong>Rillsoft Sistemas</strong> para mais informações.',
                                            showConfirmButton: false,
                                            showCloseButton: true,
                                            backdrop: false                                                
                                        }); 
                        setTimeout(function(){
                            util.gotoprincipal();
                        },4000);                                                               
                    }                    
                    if (util.opcaousuario('001Z.110Z', vself.$store.state.perfilusuario)) {
                        $('#pnlista').fadeIn(700);
                        vself.mtddefinicoesiniciais()
                        vself.mtdexecutapesquisa();
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }
        },
        computed:{
            validou() {
                return this.vdescricao === '' || this.vidconta === null || this.vidplanoconta === null ||
                this.vidcentrocusto === null || this.vidhistoricopadrao === null ||
                this.vidprovedorcusto === null || this.vdescricaomovimento === '';
            }
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregaperfis(val);
            }
        }
    }
</script>
<style>
    .def-col-cod{
        width: 80px !important;
    }
    .def-col-opcoes-perfil{
        width: 140px;
    }
</style>